import { render, staticRenderFns } from "./EmailConfirmed.vue?vue&type=template&id=740d4200&"
import script from "./EmailConfirmed.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports